import _createForOfIteratorHelper from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import React, { forwardRef } from 'react';
import { useReducedMotion } from '@mantine/hooks';
import { useComponentDefaultProps, useMantineTheme } from '@mantine/styles';
import { useCollapse } from './use-collapse.js';
import { extractSystemStyles } from '../Box/style-system-props/extract-system-styles/extract-system-styles.js';
import { Box } from '../Box/Box.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
var defaultProps = {
  transitionDuration: 200,
  transitionTimingFunction: "ease",
  animateOpacity: true
};
var Collapse = forwardRef(function (props, ref) {
  var _a = useComponentDefaultProps("Collapse", defaultProps, props),
    children = _a.children,
    opened = _a.in,
    transitionDuration = _a.transitionDuration,
    transitionTimingFunction = _a.transitionTimingFunction,
    style = _a.style,
    onTransitionEnd = _a.onTransitionEnd,
    animateOpacity = _a.animateOpacity,
    others = __objRest(_a, ["children", "in", "transitionDuration", "transitionTimingFunction", "style", "onTransitionEnd", "animateOpacity"]);
  var theme = useMantineTheme();
  var shouldReduceMotion = useReducedMotion();
  var reduceMotion = theme.respectReducedMotion ? shouldReduceMotion : false;
  var duration = reduceMotion ? 0 : transitionDuration;
  var _extractSystemStyles = extractSystemStyles(others),
    systemStyles = _extractSystemStyles.systemStyles,
    rest = _extractSystemStyles.rest;
  var getCollapseProps = useCollapse({
    opened: opened,
    transitionDuration: duration,
    transitionTimingFunction: transitionTimingFunction,
    onTransitionEnd: onTransitionEnd
  });
  if (duration === 0) {
    return opened ? /* @__PURE__ */React.createElement(Box, __spreadValues({}, rest), children) : null;
  }
  return /* @__PURE__ */React.createElement(Box, __spreadValues({}, getCollapseProps(__spreadValues(__spreadValues({
    style: style,
    ref: ref
  }, rest), systemStyles))), /* @__PURE__ */React.createElement("div", {
    style: {
      opacity: opened || !animateOpacity ? 1 : 0,
      transition: animateOpacity ? "opacity ".concat(duration, "ms ").concat(transitionTimingFunction) : "none"
    }
  }, children));
});
Collapse.displayName = "@mantine/core/Collapse";
export { Collapse };